var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-modal', {
    attrs: {
      "centered": "",
      "size": "md",
      "title": "Filter Data",
      "ok-title": "Filter"
    },
    on: {
      "ok": function ok($event) {
        return _vm.fetchUsers(1);
      }
    },
    model: {
      value: _vm.modal.filter,
      callback: function callback($$v) {
        _vm.$set(_vm.modal, "filter", $$v);
      },
      expression: "modal.filter"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": "Company",
      "label-for": "company",
      "label-cols-sm": "4",
      "label-cols-lg": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "company",
      "options": _vm.companies,
      "reduce": function reduce(company) {
        return company.id;
      },
      "placeholder": "Select Company"
    },
    model: {
      value: _vm.usersData.params.companyId,
      callback: function callback($$v) {
        _vm.$set(_vm.usersData.params, "companyId", $$v);
      },
      expression: "usersData.params.companyId"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": "Status",
      "label-for": "status",
      "label-cols-sm": "4",
      "label-cols-lg": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "text",
      "options": _vm.statuses,
      "reduce": function reduce(status) {
        return status.value;
      },
      "placeholder": "Select Status"
    },
    model: {
      value: _vm.usersData.params.active,
      callback: function callback($$v) {
        _vm.$set(_vm.usersData.params, "active", $$v);
      },
      expression: "usersData.params.active"
    }
  })], 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("Users")])])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return undefined;
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex justify-content-between mb-3"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-form-input', {
          attrs: {
            "size": "lg",
            "placeholder": "search..."
          },
          model: {
            value: _vm.usersData.params.search,
            callback: function callback($$v) {
              _vm.$set(_vm.usersData.params, "search", $$v);
            },
            expression: "usersData.params.search"
          }
        }), _c('b-button', {
          staticClass: "mx-2",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.fetchUsers(1);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search"
        })]), _c('b-button', {
          staticClass: "d-flex align-items-center",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.toggleModalFilter
          }
        }, [_c('i', {
          staticClass: "fas fa-sliders"
        }), _c('p', {
          staticClass: "text-truncate m-0"
        }, [_vm._v(" Filter Data")])])], 1), _c('div', {
          staticClass: "d-flex"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('strong', [_vm._v("Display :  ")]), _c('div', {
          staticClass: "btn-group"
        }, [_c('button', {
          staticClass: "btn btn-outline-primary",
          class: {
            active: _vm.view_style === 'list'
          },
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.view_style = 'list';
            }
          }
        }, [_c('span', {
          staticClass: "fa fa-list"
        }), _vm._v(" List ")]), _c('button', {
          staticClass: "btn btn-outline-primary",
          class: {
            active: _vm.view_style === 'grid'
          },
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.view_style = 'grid';
            }
          }
        }, [_c('span', {
          staticClass: "fa fa-th-large"
        }), _vm._v(" Grid ")])])]), _c('div', {
          staticClass: "mx-3",
          staticStyle: {
            "border-left": "1.5px solid"
          }
        }), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_vm.findMenuPermission(1, 'add', _vm.$route.query.menuId) ? _c('router-link', {
          attrs: {
            "to": {
              name: 'setting.addNewUser',
              query: {
                menuObject: _vm.$route.query.menuObject
              }
            }
          }
        }, [_c('b-button', {
          attrs: {
            "variant": "success"
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v("Add User")])], 1) : _vm._e()], 1)])]), _c('div', {
          staticClass: "px-3 mb-3"
        }, [_c('b-row', {
          staticClass: "border py-3"
        }, [_c('b-col', {
          attrs: {
            "cols": "3"
          }
        }, [_c('b-form-group', {
          staticClass: "m-0",
          attrs: {
            "label": "Company"
          }
        }, [_c('p', {
          staticClass: "m-0 text-black",
          staticStyle: {
            "font-weight": "500"
          }
        }, [_vm._v(_vm._s(_vm.usersData.params.companyId ? _vm.companies.find(function (el) {
          return el.id == _vm.usersData.params.companyId;
        }).company : 'All'))])])], 1), _c('b-col', {
          attrs: {
            "cols": "3"
          }
        }, [_c('b-form-group', {
          staticClass: "m-0",
          attrs: {
            "label": "Status"
          }
        }, [_c('p', {
          staticClass: "m-0 text-black",
          staticStyle: {
            "font-weight": "500"
          }
        }, [_vm._v(_vm._s(typeof _vm.usersData.params.active === 'boolean' ? _vm.statuses.find(function (el) {
          return el.value === _vm.usersData.params.active;
        }).text : 'All'))])])], 1)], 1)], 1), _vm.usersData._loading ? _c('div', {
          staticClass: "text-center my-5"
        }, [_c('b-spinner', {
          attrs: {
            "type": "grow",
            "label": "Spinning"
          }
        })], 1) : [_vm.view_style === 'list' ? [_c('div', {
          staticClass: "d-flex overflow-auto"
        }, [_c('table', {
          staticClass: "table table-striped"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center",
          staticStyle: {
            "max-width": "100px"
          }
        }, [_vm._v("PHOTO")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("FULL NAME")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("USERNAME")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("ROLES")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("COMPANY")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("STATUS")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("ACTION")])])]), _c('tbody', _vm._l(_vm.usersData.data, function (usr, i) {
          var _usr$userDetail$photo;
          return _c('tr', {
            key: i
          }, [_c('td', {
            staticClass: "text-center"
          }, [_c('router-link', {
            attrs: {
              "to": {
                name: 'setting.viewUser',
                params: {
                  id: usr.id
                },
                query: {
                  menuObject: _vm.$route.query.menuObject
                }
              }
            }
          }, [_c('b-img', {
            staticStyle: {
              "width": "60px",
              "height": "60px"
            },
            attrs: {
              "rounded": 'circle',
              "src": (_usr$userDetail$photo = usr.userDetail.photo) !== null && _usr$userDetail$photo !== void 0 ? _usr$userDetail$photo : _vm.handleInitialByFullname(usr.userDetail.name),
              "alt": usr.userDetail.name
            }
          })], 1)], 1), _c('td', {
            staticClass: "text-left"
          }, [_c('div', {
            staticClass: "d-flex flex-column"
          }, [_c('router-link', {
            attrs: {
              "to": {
                name: 'setting.viewUser',
                params: {
                  id: usr.id
                },
                query: {
                  menuObject: _vm.$route.query.menuObject
                }
              }
            }
          }, [_c('strong', {
            staticClass: "text-primary"
          }, [_vm._v(" " + _vm._s(usr.userDetail.name) + " ")])])], 1)]), _c('td', {
            staticClass: "text-left"
          }, [_c('div', {
            staticClass: "d-flex flex-column"
          }, [_c('strong', {
            staticClass: "mb-0"
          }, [_vm._v(_vm._s(usr.username))])])]), _c('td', {
            staticClass: "text-left"
          }, [_c('p', {
            staticClass: "mb-0"
          }, [_vm._v(_vm._s(usr.role.roles))])]), _c('td', {
            staticClass: "text-left"
          }, [_c('router-link', {
            attrs: {
              "to": {
                name: 'setting.viewUser',
                params: {
                  id: usr.id
                },
                query: {
                  menuObject: _vm.$route.query.menuObject
                }
              }
            }
          }, [_c('p', {
            staticClass: "mb-2"
          }, [_vm._v(_vm._s(usr.company.company))])])], 1), _c('td', {
            staticClass: "text-center"
          }, [_c('b-badge', {
            attrs: {
              "variant": usr.active ? 'primary' : 'danger'
            }
          }, [_vm._v(" " + _vm._s(usr.active ? 'Active' : 'Not Active') + " ")])], 1), _vm.findMenuPermission(1, 'update', _vm.$route.query.menuId) ? _c('td', {
            staticClass: "text-center"
          }, [_c('router-link', {
            attrs: {
              "to": {
                name: 'setting.EditUser',
                params: {
                  id: usr.id
                },
                query: {
                  menuId: _vm.$route.query.menuId
                }
              }
            }
          }, [_c('b-button', {
            staticClass: "mt-2",
            attrs: {
              "variant": "success",
              "size": "sm"
            }
          }, [_c('i', {
            staticClass: "fa fa-edit"
          }), _vm._v(" Edit ")])], 1)], 1) : _vm._e()]);
        }), 0)])])] : _vm._e(), _vm.view_style === 'grid' ? [_vm.usersData.data && _vm.usersData.data.length > 0 ? _c('b-row', _vm._l(_vm.usersData.data, function (usr, i) {
          var _usr$userDetail$photo2;
          return _c('b-col', {
            key: i,
            attrs: {
              "sm": "12",
              "md": "3"
            }
          }, [_c('b-card', [_c('b-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('router-link', {
            attrs: {
              "to": {
                name: 'setting.viewUser',
                params: {
                  id: usr.id
                },
                query: {
                  menuObject: _vm.$route.query.menuObject
                }
              }
            }
          }, [_c('b-img', {
            staticStyle: {
              "width": "100px",
              "height": "100px"
            },
            attrs: {
              "rounded": 'circle',
              "src": (_usr$userDetail$photo2 = usr.userDetail.photo) !== null && _usr$userDetail$photo2 !== void 0 ? _usr$userDetail$photo2 : _vm.handleInitialByFullname(usr.userDetail.name),
              "alt": usr.userDetail.name
            }
          })], 1)], 1), _c('div', {
            staticClass: "text-center mt-3"
          }, [_c('router-link', {
            attrs: {
              "to": {
                name: 'setting.viewUser',
                params: {
                  id: usr.id
                },
                query: {
                  menuObject: _vm.$route.query.menuObject
                }
              }
            }
          }, [_c('h4', [_vm._v(" " + _vm._s(usr.userDetail.name) + " ")])]), _c('strong', {
            staticClass: "mb-0"
          }, [_vm._v(_vm._s(usr.username))]), _c('p', {
            staticClass: "mb-0"
          }, [_vm._v(_vm._s(usr.role.roles))]), _c('router-link', {
            attrs: {
              "to": {
                name: 'setting.viewUser',
                params: {
                  id: usr.id
                },
                query: {
                  menuObject: _vm.$route.query.menuObject
                }
              }
            }
          }, [_vm._v(_vm._s(usr.company.location))])], 1), _c('div', {
            staticClass: "text-center mt-2"
          }, [_c('p', {
            staticClass: "mb-0"
          }, [_vm._v(_vm._s(usr.company.company))]), _c('p', {
            staticClass: "mb-0"
          }, [_c('b-badge', {
            staticClass: "ml-2",
            attrs: {
              "variant": usr.active ? 'warning' : 'danger'
            }
          }, [_vm._v(" " + _vm._s(usr.active ? 'Active' : 'Not Active') + " ")])], 1)])]), _vm.findMenuPermission(1, 'update', _vm.$route.query.menuId) ? _c('b-card-footer', {
            staticClass: "text-center"
          }, [_c('router-link', {
            attrs: {
              "to": {
                name: 'setting.EditUser',
                params: {
                  id: usr.id
                },
                query: {
                  menuId: 'anjayyyy'
                }
              }
            }
          }, [_c('b-button', {
            staticClass: "mt-2",
            attrs: {
              "variant": "success",
              "size": "sm"
            }
          }, [_c('i', {
            staticClass: "fa fa-edit"
          }), _vm._v(" Edit")])], 1)], 1) : _vm._e()], 1)], 1);
        }), 1) : _vm._e()] : _vm._e(), _vm.usersData.data && _vm.usersData.data.length > 0 ? _c('div', {
          staticClass: "mt-4"
        }, [_c('b-pagination', {
          attrs: {
            "total-rows": _vm.usersData.meta.total,
            "per-page": _vm.usersData.meta.perPage,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": _vm.fetchUsers
          },
          model: {
            value: _vm.usersData.meta.currentPage,
            callback: function callback($$v) {
              _vm.$set(_vm.usersData.meta, "currentPage", $$v);
            },
            expression: "usersData.meta.currentPage"
          }
        })], 1) : _c('p', {
          staticClass: "mb-0 text-muted text-center"
        }, [_vm._v("No users data found.")])]];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }